module.exports = __webpack_public_path__ + "img/5yina_thumbnail.f2687e85.jpg";